/**
 * 随机生成uuid
 * @return string 生成的uuid
 */
export function randomUUID() {
  const chats = "0123456789abcdef";
  return randomString(32, chats);
}

export function generateRandomAlphaNum(len) {
  var rdmString = "";
  for (; rdmString.length < len; rdmString += Math.random().toString(36).substr(2));
  return rdmString.substr(0, len);
}

/**
 * 随机生成字符串
 * @param length 字符串的长度
 * @param chats 可选字符串区间（只会生成传入的字符串中的字符）
 * @return string 生成的字符串
 */
export function randomString(length, chats) {
  if (!length) length = 1;
  if (!chats) chats = "0123456789qwertyuioplkjhgfdsazxcvbnm";
  let str = "";
  for (let i = 0; i < length; i++) {
    const num = randomNumber(0, chats.length - 1);
    str += chats[num];
  }
  return str;
}
/**
 * 随机生成数字
 *
 * 示例：生成长度为 12 的随机数：randomNumber(12)
 * 示例：生成 3~23 之间的随机数：randomNumber(3, 23)
 *
 * @param1 最小值 | 长度
 * @param2 最大值
 * @return int 生成后的数字
 */
export function randomNumber() {
  // 生成 最小值 到 最大值 区间的随机数
  const random = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
  };
  if (arguments.length === 1) {
    const [length] = arguments;
    // 生成指定长度的随机数字，首位一定不是 0
    const nums = [...Array(length).keys()].map((i) =>
      i > 0 ? random(0, 9) : random(1, 9)
    );
    return parseInt(nums.join(""));
  } else if (arguments.length >= 2) {
    const [min, max] = arguments;
    return random(min, max);
  } else {
    return Number.NaN;
  }
}

export const ImagePreviewListener = (event,$vm) => {
  // vShowContent
  event = event ? event : window.event;
  let ele = event.srcElement ? event.srcElement : event.target;
  if (ele.tagName === 'IMG') {
      if ($vm.imageClick != null) {
          // 覆盖图片点击事件
          $vm.imageClick(ele);
      } else {
        if(ele.src.indexOf('/eco/preview')>-1){
          $vm.preview_imgsrc = ele.src+"_l";
        }else{
          $vm.preview_imgsrc = ele.src;
        }
      }
  }
}

export const colorRgb = (sColor) => {
  sColor = sColor.toLowerCase();
  //十六进制颜色值的正则表达式
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 如果是16进制颜色
  if (sColor && reg.test(sColor)) {
      if (sColor.length === 4) {
          var sColorNew = "#";
          for (var i=1; i<4; i+=1) {
              sColorNew += sColor.slice(i, i+1).concat(sColor.slice(i, i+1));    
          }
          sColor = sColorNew;
      }
      //处理六位的颜色值
      var sColorChange = [];
      for (var i=1; i<7; i+=2) {
          sColorChange.push(parseInt("0x"+sColor.slice(i, i+2)));
      }
      return "rgba(" + sColorChange.join(",") + ",.2)";
  }
  return sColor;
}

// 代码块复制
import Clipboard from 'clipboard'

// className 是点击的元素的class，url是复制的内容
export const shareURL = (className, url, $vm) => {
  let clipboard = new Clipboard('.' + className, {
    text: function () {
      return url
    }
  })
  clipboard.on('success', e => {
    $vm.$message.success('复制成功！')
    // 其他处理代码
    // {...}
    // 释放内存
    clipboard.destroy()
  })
  clipboard.on('error', e => {
    $vm.$message.success('复制失败,需手动复制链接！')
    clipboard.destroy()
  })
  // 其他处理的代码不能写在外面，会导致复制失败
}

// 添加复制操作
export const addCopyBtn = ($vm, $dom) => {
  $vm.$nextTick(()=>{
    const contents = Array.from($dom.getElementsByClassName('v-show-content'))
    for (let i = 0; i < contents.length; i++) {
      const content = contents[i];
      const precodes = content.getElementsByTagName('pre')
      // precodes 是个类数组 ，转换一下
      const arr = Array.from(precodes)
      for (let j = 0; j < arr.length; j++) {
        const element = arr[j];
        if(element.querySelector('.code-copy')) {
          continue;
        }
        const btn = document.createElement('p');
        btn.innerHTML = '复制';
        btn.setAttribute("class",'code-copy' );
        
        btn.addEventListener('click', function(e) {
          let p_prime = e.target.parentElement.cloneNode(true);
          let copy = p_prime.querySelector('.code-copy');
          p_prime.removeChild(copy);
          let innerText = p_prime.innerText
          // let innerText = e.target.parentElement.querySelector('code').innerText
          // console.log(1111111, innerText)
          // 复制函数
          shareURL('code-copy', innerText, $vm, false)  
        })
        element.appendChild(btn)
      }
      
    }
  })
}

